import { useScreenWidth } from "@msys/ui";
import { Box, Stack, Typography } from "@mui/material";
import { useTranslate } from "@tolgee/react";
import { LogoutButton } from "../auth/LogoutButton.js";
import { LanguageSelector } from "../commons/LanguageSelector.js";
import { Page } from "../commons/layout/Page.js";
import { PageContainer } from "../commons/layout/PageContainer.js";

interface Props {
  isAuthenticated: boolean;
}

export const InvitationPage = ({
  isAuthenticated,
  children,
}: React.PropsWithChildren<Props>) => {
  const { isMinTablet } = useScreenWidth();
  const { t } = useTranslate(["PageSignup"]);

  return (
    <Page
      hideNavigation
      isTopBarVisible
      topbarItems={
        <>
          {isAuthenticated && <LogoutButton color={"inherit"} />}
          <LanguageSelector />
        </>
      }
    >
      <PageContainer $fullHeight $noPadding>
        <Stack
          direction={isMinTablet ? "row" : "column"}
          spacing={2}
          sx={{
            height: "100%",
          }}
        >
          <Stack
            spacing={1}
            sx={{
              flexGrow: 2,
              flexBasis: 0,
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
              paddingY: 6,
              paddingX: 2,
            }}
          >
            <Stack
              sx={{
                flexDirection: "column",
                alignItems: "center",
                width: "100%",
                justifyContent: "center",
                pb: 4,
              }}
            >
              {children}
            </Stack>
          </Stack>
          <Stack
            direction="column"
            sx={{
              flex: 1,
              flexBasis: 0,
              justifyContent: "center",
              paddingY: 3,
              paddingLeft: 2,
              backgroundColor: "#033099",
            }}
          >
            <Box
              sx={{
                pb: 3,
                px: 2,
                alignSelf: "center",
              }}
            >
              <Typography
                variant="h2"
                align="center"
                sx={theme => ({
                  color: theme.palette.common.white,
                  fontSize: "1.375rem",
                  lineHeight: 1.2,
                  [theme.breakpoints.up(theme.breakpoints.values.tablet)]: {
                    fontSize: "1.5rem",
                    lineHeight: 1.2,
                  },
                  [theme.breakpoints.up(theme.breakpoints.values.xl)]: {
                    fontSize: "1.75rem",
                    lineHeight: 1.2,
                  },
                })}
              >
                {t(
                  "Strap on your tool belts, welcome to the future of construction",
                  { ns: "PageSignup" }
                )}
              </Typography>
            </Box>
            <Box
              sx={{
                width: "100%",
                backgroundImage: "url(/auth/auth-client.svg)",
                backgroundSize: "contain",
                paddingTop: "96.15384615%",
              }}
            ></Box>
          </Stack>
        </Stack>
      </PageContainer>
    </Page>
  );
};
